<template>
    <div class="body">
        <header-select />
        <div class="main">
            <div class="nav_banner1">
                <my-menu></my-menu>
                <div class="nr_banner">
                    <img src="@/assets/images/fx_banner.jpg" width="965" height="207" alt="风险控制" title="风险控制" />
                </div>
            </div>
            <div class="er_main" >
                <index-item :datalist="datalist"></index-item>
            </div>
            <div class="clear"></div>
            <div class="footer">
                <my-footer></my-footer>
            </div>
        </div>
    </div>
</template>

<script>
    import headerSelect from "@/views/Component/header";
    import myMenu from "@/views/Component/myMenu";
    import myFooter from "@/views/Component/myFooter";
    import indexItem from "@/views/Risk/childPage/indexItem";
    export default {
        name: "RiskIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司-风险控制',
            meta:[{name: 'keyWords', content:'风险控制，官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"风险控制，官网，中国医药行业内风险控制领域的服务提供商"},
            ]
        },
        data() {
            return {
                datalist:[],
            }
        },
        components:{
            headerSelect,myMenu,myFooter,indexItem
        },
        mounted() {
            document.body.style.backgroundColor = '#daecec';
            this.getRiskData();
        },
        methods: {
            getRiskData(){
                this.$HTTP.getRiskData().then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        for(let i=0; i < data.length ; i++){
                            let item = data[i];
                            //item.content = '&nbsp;&nbsp;&nbsp;&nbsp;' + item.content; //内容增加空
                            this.datalist.push(item);
                        }
                    }
                });
            },
        },
        computed: {

        },
        watch: {
        },
        beforeDestroy() {
        }
    }
</script>

<style lang="scss" scoped>
    *{ margin:0; padding:0;}
    .body{ color:#666; font:12px "宋体";background:#daecec;}
    .main{width:1001px;height:auto !important;height:500px;min-height:500px;margin:0 auto;background:url("../../assets/images/bg_main_07.jpg") repeat-y;border:1px solid #d9dde2;margin-bottom:50px;}
    .nav_banner1{width:1001px;height:305px;position:relative;}
    .nr_banner{width:965px;height:207px;position:absolute;left:17px;top:98px;}

</style>
